import React from "react";
import { DEVICE_WIDTH } from "./utils";
var ResponsiveContext = /* @__PURE__ */ React.createContext({
  isSSR: false,
  deviceWidth: DEVICE_WIDTH.desktop
});
export {
  ResponsiveContext
};
